import React, { useState, useRef } from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Container,
  Button,
  Chip,
} from '@mui/material';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';

import {
  services,
  SERVICE_SECTION_ID,
  SERVICE_BANNER_TITLE,
  SWIPER_CONFIG,
  REQUEST_QUOTE_LABEL,
} from '../data/Services';

import { secondaryButtonStyles } from '../styles/Base';

import {
  sectionStyles,
  bannerWrapperStyles,
  bannerImageStyles,
  bannerTitleStyles,
  chipContainerStyles,
  chipStyles,
  swiperWrapperStyles,
  cardStyles,
  cardHeaderStyles,
  iconBoxStyles,
  iconImageStyles,
  cardTitleStyles,
  cardContentStyles,
  buttonWrapperStyles,
} from '../styles/Services.js';

import { prefillContactMessage } from '../utils/contactHelper.js';

const Services = () => {
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [slidesPerView, setSlidesPerView] = useState(1);

  const middleIndex = (activeIndex + Math.floor(slidesPerView / 2)) % services.length;

  const handleSelect = (index) => {
    if (!swiperRef.current) return;

    const shift = Math.floor(slidesPerView / 2);
    let targetIndex = index - shift;

    if (targetIndex < 0) {
      targetIndex = services.length + targetIndex;
    }

    swiperRef.current.slideToLoop(targetIndex);
  };

  return (
    <Box id={SERVICE_SECTION_ID} component="section" sx={sectionStyles}>
      {/* Banner */}
      <Box sx={bannerWrapperStyles}>
        <Box sx={bannerImageStyles} />
        <Typography variant="h3" sx={bannerTitleStyles}>
          {SERVICE_BANNER_TITLE}
        </Typography>
      </Box>

      <Container maxWidth="lg">
        {/* Chips */}
        <Box sx={{ mb: 6 }}>
          <Box sx={chipContainerStyles}>
            {services.map((service, index) => {
              const isActive = middleIndex === index;

              return (
                <Chip
                  key={service.id}
                  label={service.title}
                  onClick={() => handleSelect(index)}
                  color={isActive ? 'primary' : 'default'}
                  variant={isActive ? 'filled' : 'outlined'}
                  sx={chipStyles(isActive)}
                />
              );
            })}
          </Box>
        </Box>

        {/* Swiper */}
        <Box sx={swiperWrapperStyles}>
          <Swiper
            modules={[Pagination, Autoplay]}
            {...SWIPER_CONFIG}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
              setSlidesPerView(swiper.params.slidesPerView || 1);
            }}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          >
            {services.map((service, index) => {
              const isMiddle = index === middleIndex;

              return (
                <SwiperSlide
                  key={service.id}
                  style={{ display: 'flex', justifyContent: 'center' }}
                >
                  <Card elevation={4} sx={cardStyles(isMiddle)}>
                    <Box sx={cardHeaderStyles}>
                      <Box sx={iconBoxStyles}>
                        <Box
                          component="img"
                          src={service.icon}
                          alt={service.title}
                          sx={iconImageStyles}
                        />
                      </Box>
                      <Typography variant="h6" component="h3" sx={cardTitleStyles}>
                        {service.title}
                      </Typography>
                    </Box>
                    <CardContent sx={cardContentStyles}>
                      {service.description}
                    </CardContent>
                  </Card>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Box>

        {/* Button */}
        <Box sx={buttonWrapperStyles}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={secondaryButtonStyles}
            onClick={() => prefillContactMessage()}
          >
            {REQUEST_QUOTE_LABEL}
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default Services;
